(function () {

    var fixExternLinks = function () {
        document.querySelectorAll('a[href]').forEach(function (a) {
            if (a.href.indexOf('javascript') == 0) return;

            try {
                var link = new URL(a.href);
                if (link.host != document.location.host) {
                    a.setAttribute('target', '_blank');
                    a.setAttribute('rel', 'noopener noreferrer');
                }
            } catch (e) { console.error(e) }
        });
    }


    fixExternLinks();

})();
